/**
 * Runtime configuration: one image serves every customer. The container writes /config.js from its
 * environment at start (docker/40-runtime-config.sh), index.html loads it before the app; a value
 * left empty falls back to the build (.env, .env.production).
 */
interface RuntimeConfig {
  /** the customer's pizza-backend, e.g. https://pizza-checker-api.algovectra.com */
  backendUrl?: string;
}

declare global {
  interface Window {
    __PIZZA_CONFIG__?: RuntimeConfig;
  }
}

const runtime: RuntimeConfig = (typeof window !== "undefined" && window.__PIZZA_CONFIG__) || {};

export const backendUrl: string = runtime.backendUrl || import.meta.env.VITE_BACKEND_URL || "/api";
